import { h } from 'preact';
import PropTypes from 'prop-types';

import PlaylistCarouselInline from '../../containers/playlist-carousel-inline/playlist-carousel-inline';

export const CarouselInlineComponent = ({ htmlProps, widget, $root }) => (
  <PlaylistCarouselInline htmlProps={htmlProps} widget={widget} $root={$root} />
);

CarouselInlineComponent.propTypes = {
  htmlProps: PropTypes.object.isRequired,
  $root: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};
